/**
 * Configuration for local environment.
 */
const local = {
  msal: {
    CLIENT_ID: 'a20523ac-7c6d-435d-b56e-0bc7082c0814'
  }
};

/**
 * Configuration for the development environment.
 */
const development = {
  msal: {
    CLIENT_ID: 'a20523ac-7c6d-435d-b56e-0bc7082c0814'
  }
};

/**
 * Configuration for the test environment.
 */
const test = {
  msal: {
    CLIENT_ID: '63b836f2-4697-4f39-9355-2fbd3b760ee8'
  }
};

/**
 * Configuration for the production environment.
 */
const production = {
  msal: {
    CLIENT_ID: '39871fbf-a4ee-40ac-92dc-a8b79917b45d'
  }
};

const env = process.env.ENV || 'Local';

const envConfiguration = () => {
  let environmentConfig;

  if (env === 'Production') {
    environmentConfig = production;
  } else if (env === 'Test') {
    environmentConfig = test;
  } else if (env === 'Development') {
    environmentConfig = development;
  } else if (env === 'Local') {
    environmentConfig = local;
  } else {
    environmentConfig = local;
  }

  return environmentConfig;
};

const envConfig = envConfiguration();

const config = {
  msal: {
    AUTHORITY:
      'https://login.microsoftonline.com/258f1f99-ee3d-42c7-bfc5-7af1b2343e02',
    REDIRECT_URI: '/',
    POST_LOGOUT_REDIRECT_URI: '/',
    ...envConfig.msal,
    TOKEN_DEFAULT_SCOPE: `api://${envConfig.msal.CLIENT_ID}/Vetting.Access`,
  },
};

export { config };
